function isPlainObject(value) {
  return value !== null && typeof value === "object" && !Array.isArray(value);
}

export function deepMerge(base, override) {
  if (override === undefined || override === null) return base;
  if (!isPlainObject(override)) return override;
  if (!isPlainObject(base)) return { ...override };

  const result = { ...base };
  for (const key of Object.keys(override)) {
    result[key] = deepMerge(base[key], override[key]);
  }
  return result;
}
